// extracted by mini-css-extract-plugin
module.exports = {"container":"last_articles_container-module_container_8cb73","list":"last_articles_container-module_list_c9fec","title":"last_articles_container-module_title_7649a"};